import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(roomId, listingId) {
    const response = await api.fetch(`/api/v2/airbnb/connect`, {
      method: 'DELETE',
      body: JSON.stringify({
        id_room: roomId,
        id_listing: listingId,
      }),
    })
    return await handleResponse(response)
  }
}
